import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=424e4366&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('424e4366')) {
      api.createRecord('424e4366', component.options)
    } else {
      api.reload('424e4366', component.options)
    }
    module.hot.accept("./ProductCard.vue?vue&type=template&id=424e4366&", function () {
      api.rerender('424e4366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductCard.vue"
export default component.exports